export enum ClubPage {
    Records = 'records',
    History = 'history',
    Coaches = 'coaches',
}
